/**
 * Sort reasons WITHOUT translation.
 * Priority:
 *  1. Reasons starting with any of the supplied words (case-insensitive)
 *     (exact word or word + space at start)
 *  2. Then alphabetical (case-insensitive)
 *
 * @param {Object} params
 * @param {string[]} params.reasons  Array of reason strings (or values coercible to string)
 * @param {string[]|string} params.words  Starter word(s) (e.g. ["new","nouveau","nouvelle"])
 * @param {Function} [params.getValue]   Optional accessor: item => string
 * @returns {Array} sorted reasons (same item references)
 */
export const sortReasons = ({ reasons, words, getValue }) => {
  if (!Array.isArray(reasons)) return reasons || [];

  const starterWords = Array.isArray(words) ? words : [words].filter(Boolean);
  const loweredStarters = starterWords.map((w) => w.toLowerCase());
  const accessor = typeof getValue === "function" ? getValue : (r) => r;

  const isStarter = (val) => {
    const lower = val.trim().toLowerCase();
    return loweredStarters.some(
      (w) => lower === w || lower.startsWith(w + " ")
    );
  };

  return [...reasons].sort((a, b) => {
    const aStr = String(accessor(a) ?? "").trim();
    const bStr = String(accessor(b) ?? "").trim();

    const aStart = aStr && isStarter(aStr);
    const bStart = bStr && isStarter(bStr);
    if (aStart !== bStart) return aStart ? -1 : 1;

    return aStr.localeCompare(bStr, undefined, { sensitivity: "base" });
  });
};

export default sortReasons;
